document.addEventListener("DOMContentLoaded", function () {
	const lists = document.querySelectorAll(
		"ul.wp-block-list.is-style-checkmarks"
	);

	if (!lists.length) return;

	function revealListIfCentered(list) {
		const rect = list.getBoundingClientRect();
		const elemCenter = rect.top + rect.height / 2;
		const viewportCenter = window.innerHeight / 2;
		const distance = Math.abs(elemCenter - viewportCenter);

		if (distance < 300 && !list.classList.contains("in-view")) {
			list.classList.add("in-view");
			return true;
		}
		return false;
	}

	function observeLists() {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					if (revealListIfCentered(entry.target)) {
						obs.unobserve(entry.target);
					}
				});
			},
			{
				threshold: [0, 0.25, 0.5, 0.75, 1],
			}
		);

		lists.forEach((list) => observer.observe(list));
	}

	// Attach observer after layout is painted
	window.requestAnimationFrame(observeLists);

	// Fallback: On scroll/resize, check all lists that haven't been revealed
	function fallbackCheck() {
		lists.forEach((list) => {
			if (!list.classList.contains("in-view")) {
				revealListIfCentered(list);
			}
		});
	}
	window.addEventListener("scroll", fallbackCheck, { passive: true });
	window.addEventListener("resize", fallbackCheck);
});
